<template>
  <div id="wrapper" class="gray-bg login-bg">
    <div class="container">

      <div class="row">
        <div class="col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">

          <div class="login">

            <div class="logo">
              <h1>Account Created</h1>
            </div>

            <div class="login-content">
              <div class="swal2-show">
                <div class="swal2-icon swal2-success swal2-animate-success-icon" style="display: block;">
                  <div class="swal2-success-circular-line-left" style="background: rgb(255, 255, 255);"></div>
                  <span class="swal2-success-line-tip swal2-animate-success-line-tip"></span>
                  <span class="swal2-success-line-long swal2-animate-success-line-long"></span>
                  <div class="swal2-success-ring"></div>
                  <div class="swal2-success-fix" style="background: rgb(255, 255, 255);"></div>
                  <div class="swal2-success-circular-line-right" style="background: rgb(255, 255, 255);"></div>
                </div>
              </div>

              <div class="margin-20"></div>

              <p class="m-b-lg lead">An email has been sent for verification. Please go to your inbox and click the link to validate your newly created account.</p>

              <p class="m-b-lg">
                <a @click="handleSendEmail">
                  Re-send email verification.
                  <i v-show="sendingVerificationEmail" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
                </a>
              </p>

              <p class="m-b-lg">
                <router-link :to="{ name: 'auth.logout' }" class="btn btn-primary">Return to login screen</router-link>
              </p>

            </div>


          </div><!-- /.login -->

        </div>
      </div><!-- /.login -->

    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import notify from 'utils/notify'
  import { mapActions } from 'vuex'

  export default {
    data () {
      return {
        sendingVerificationEmail: false
      }
    },

    mounted () {
      $('body').addClass('pace-top')
    },

    created () {
      if (this.$user.email_verified) {
        this.$router.push({ name: 'dashboard' })
      }
    },

    methods: {
      ...mapActions('user', ['sendVerificationMail']),

      handleSendEmail () {
        const unableToSendEmail = () => {
          this.sendingVerificationEmail = false

          notify.error('Unable to re-send verification email.')
        }

        const emailSent = () => {
          this.sendingVerificationEmail = false

          notify.success('We sent you another verification email.')
        }

        this.sendingVerificationEmail = true

        return this.sendVerificationMail(this.$user.email).then(emailSent).catch(unableToSendEmail)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RegisterSuccess.vue?3e138a76